import React, { forwardRef } from 'react';
const Table = forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(({
  className = '',
  ...props
}, ref) => <div className="relative w-full overflow-auto" data-id="element-167">
    <table ref={ref} className={`w-full caption-bottom text-sm ${className}`} {...props} data-id="element-168" />
  </div>);
Table.displayName = 'Table';
const TableHeader = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className = '',
  ...props
}, ref) => <thead ref={ref} className={`[&_tr]:border-b ${className}`} {...props} data-id="element-169" />);
TableHeader.displayName = 'TableHeader';
const TableBody = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className = '',
  ...props
}, ref) => <tbody ref={ref} className={`[&_tr:last-child]:border-0 ${className}`} {...props} data-id="element-170" />);
TableBody.displayName = 'TableBody';
const TableRow = forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(({
  className = '',
  ...props
}, ref) => <tr ref={ref} className={`border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted ${className}`} {...props} data-id="element-171" />);
TableRow.displayName = 'TableRow';
const TableHead = forwardRef<HTMLTableCellElement, React.ThHTMLAttributes<HTMLTableCellElement>>(({
  className = '',
  ...props
}, ref) => <th ref={ref} className={`h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 ${className}`} {...props} data-id="element-172" />);
TableHead.displayName = 'TableHead';
const TableCell = forwardRef<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>(({
  className = '',
  ...props
}, ref) => <td ref={ref} className={`p-4 align-middle [&:has([role=checkbox])]:pr-0 ${className}`} {...props} data-id="element-173" />);
TableCell.displayName = 'TableCell';
export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };